const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class HotspotCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      rootMargin: '-45%',
      threshold: 0,
    })

    this.observer.observe(this)
  }

  setupListeners () {
    super.setupListeners()

    this.handleTriggerClick = this.handleTriggerClick.bind(this)

    this.els.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTriggerClick)
    })

    this.handleButtonClick = this.handleButtonClick.bind(this)

    this.els.button?.elements.forEach((buttonEl) => {
      this.listeners.add(buttonEl, 'click', this.handleButtonClick)
    })
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    this.classList.add('sec-Hotspots-active')

    observer.unobserve(this)
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    const triggers = this.els?.trigger?.elements
    const firstFront = Array.from(triggers).find(
      (triggerEl) => triggerEl.dataset.view === 'front',
    )
    const initialIndex = firstFront
      ? parseInt(firstFront.dataset.index, 10)
      : 0

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        initial: initialIndex,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          gap: 0,
        },
        slideChanged: (instance) => {
          const activeIndex = instance.track.details.rel

          this.els.trigger.elements.forEach((triggerEl) => {
            triggerEl.setAttribute(
              'aria-pressed',
              triggerEl.dataset.index === activeIndex.toString(),
            )
          })

          this.els.slide.elements.forEach((slideEl) => {
            slideEl.setAttribute(
              'aria-hidden',
              slideEl.dataset.index !== activeIndex.toString(),
            )
          })
        },
      },
      [setInitialised()],
    )
  }

  handleTriggerClick (event) {
    const clickedTrigger = event.target
    const targetIndex = parseInt(clickedTrigger.dataset.index, 10)

    this.carousel.moveToIdx(targetIndex, true, { duration: 0 })
  }

  handleButtonClick (event) {
    const clickedButton = event.currentTarget
    const type = clickedButton.dataset.type
    const isBack = type === 'back'

    this.els.button.elements.forEach((buttonEl) => {
      buttonEl.setAttribute('aria-pressed', buttonEl === clickedButton)
    })

    this.els.front.element.setAttribute('aria-hidden', isBack)
    this.els.back.element.setAttribute('aria-hidden', !isBack)

    const triggers = this.els?.trigger?.elements
    const firstMatch = triggers.find(
      (triggerEl) => triggerEl.dataset.view === type,
    )
    const firstIndex = firstMatch ? parseInt(firstMatch.dataset.index, 10) : 0

    triggers.forEach((triggerEl) => {
      const matches = triggerEl.dataset.view === type
      triggerEl.setAttribute('aria-hidden', !matches)
      triggerEl.setAttribute('aria-pressed', triggerEl === firstMatch)
    })

    this.carousel.moveToIdx(firstIndex, true, { duration: 0 })
  }
}

if (!customElements.get('hotspot-carousel')) {
  customElements.define('hotspot-carousel', HotspotCarousel)
}
